import { MenuItem, Select, useTheme } from "@mui/material";

import { TextLlm } from "Infrastructure/Api/Api";

const TEXT_LLM_LABELS: Record<TextLlm, string> = {
  [TextLlm.OpenAI_ChatGpt5]: "ChatGPT",
};

interface LlmModelSelectProps {
  value: TextLlm;
  onChange: (value: TextLlm) => void;
}

export const LlmModelSelect = ({
  value,
  onChange,
}: LlmModelSelectProps): React.ReactNode => {
  const theme = useTheme();

  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as TextLlm)}
      variant="outlined"
      size="small"
      sx={{
        fontSize: "11px",
        height: 26,
        "& .MuiSelect-select": {
          px: 2,
          color: theme.palette.text.secondary,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.colors.border,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.primary.main,
        },
        "& .MuiSvgIcon-root": {
          fontSize: 14,
          right: 4,
          color: theme.palette.text.secondary,
        },
      }}
    >
      {(Object.values(TextLlm) as TextLlm[]).map((llm) => (
        <MenuItem key={llm} value={llm} sx={{ fontSize: "12px" }}>
          {TEXT_LLM_LABELS[llm] ?? llm}
        </MenuItem>
      ))}
    </Select>
  );
};
